/* eslint-disable react/jsx-max-props-per-line */
import { Terms } from '../components/footer-terms/Terms';
import Form from '../components/form/Form';
import { useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';

import '../index.css';
import './NiceJobScreen.css';
import AnimatedSnowImage from '../components/AnimatedSnowImage';

const NiceJobScreen = () => {
  const [searchParams] = useSearchParams();
  const [score, setScore] = useState('0');
  const [beforeTargetDate, setBeforeTargetDate] = useState(true);
  // const [cards, setCards] = useState('0');

  useEffect(() => {
    try {
      const scoreParam = searchParams.get('score');
      // const cardsParam = searchParams.get('cards');
      setScore(scoreParam || '0');
      // setCards(cardsParam || '0');
    } catch (err) {
      setScore('0');
      // setCards('0');
      // eslint-disable-next-line no-console
      console.error('Error reading searchParams:', err);
    }
  }, [searchParams]);

  useEffect(() => {
    function hasDateTimePassedInUtc(year, month, day, hours, minutes) {
      const now = new Date();
      const targetDateTime = new Date(
        Date.UTC(year, month - 1, day, hours, minutes, 0, 0)
      );
      return now >= targetDateTime;
    }

    const hasPassed = hasDateTimePassedInUtc(2026, 1, 5, 4, 59);

    if (hasPassed) {
      setBeforeTargetDate(false);
    }
  }, []); // Empty dependency array ensures this effect runs only once, on mount

  const generateTitle = points => {
    if (points >= 15000) {
      return 'Elite Gifter';
    } else if (points >= 6001) {
      return 'Solid Stacker';
    } else {
      return 'First Timer';
    }
  };

  return (
    <div className='nice-job-page bg-screen blue-bg full-screen'>
      <div className='nice-job-content'>
        <AnimatedSnowImage />
        <img
          src='/assets/snowman-background.png'
          alt='Snowman'
          width='90%'
          className='nicejob-image'
        />
        <span className='text-gold nice-job-title'>
          {generateTitle(Number(score))}
        </span>
        <span className='text-gold nice-job-subtitle'>
          {score} points <br />
          {/* {cards} Holiday scratch-off gifts */}
        </span>
        <img
          className='tickets-image-nice-job'
          src='/assets/snowman-tickets-small.png'
          alt='Snowman'
          width='100'
        />
        {beforeTargetDate ? (
          <Form setFormSubmitted={() => {}} />
        ) : (
          <div className={'finishedMessage'}>This promotion has concluded, winners will be contacted by email. Thank you for playing!</div>
        )}
        <Terms color='white' showShareButtons shareButtonsRedirect={false} />
      </div>
    </div>
  );
};

export default NiceJobScreen;
